<template>
  <div class="step-container">
    <div v-for="(step, index) in t.steps" :key="index" class="step">
      <div :class="['step-number',
                    { 'current-step': curStep === index + 1 },
                    { 'finished-step': curStep > index + 1 || curStep === t.steps.length }
                   ]"
      >
        <template v-if="curStep > index + 1 || curStep === t.steps.length">
          <font-awesome-icon icon="check" />
        </template>
        <template v-else>
          {{ index + 1 }}
        </template>
      </div>
      <div :class="['step-name', { 'current-step-name': curStep === index + 1 }]">
        {{ step }}
      </div>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import useStepNavigation from "@/composables/useStepNavigation";
import useTexts from "@/composables/useTexts";

library.add(faCheck)  // Add the icon to the library

export default {
  name: 'ReservationSteps',
  components: {
    FontAwesomeIcon  // Register FontAwesomeIcon as a component
  },
  setup() {
    const { curStep } = useStepNavigation();
    const { getTextsForComponent } = useTexts();
    const t = getTextsForComponent('ReservationSteps');

    return {
      t,
      curStep
    }
  }
}
</script>

<style scoped>
.step-container {
  display: flex;
  justify-content: space-between;
  background-color: #e9e9e9;
  padding: 10px;
  border-radius: 4px;
}

.step {
  display: flex;
  align-items: center;
}

.step-number {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0px;
  color: black;
  background-color: #ffffff;
  font-size: 20px;
  //padding: 5px 0 0 0;
  font-weight: bold;
  text-align: center;
}

.step-name {
  margin-left: 10px;
  color: black;
  font-size: 1.2em;
  font-weight: bold;
  padding-top: 4px;
}

.current-step {
  background-color: #2e8e83;
  color: white;
}

.finished-step {
  background-color: #fcd700;
  color: #2e8e83;
}

.current-step-name {
  color: #2e8e83;
}
</style>
